import React, { useState, useEffect  } from 'react';
import { Helmet } from 'react-helmet';
import { message, Spin  } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../styles/Dashboard.css';
import NavBar from '../components/ApplicationsList/NavBar';
import ApplicationsListContent from '../components/ApplicationsList/ApplicationsListContent';
import { API_URL, API_username, API_password } from '../utils/api';

function ApplicationsList() {
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		getlistapplications();	
	}, []);
	const navigate = useNavigate();

	const [applicationsData, setApplicationsData] = useState([]);
  	
	const getlistapplications = () => {
		let apiUrl = `${API_URL}/lk?method=getlistapplications&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, авторизуйтесь заново!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				setApplicationsData(data.ApprovalApplications);
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => setLoading(false));
	};

	const handleSetActive = (e) => {
		const activeElements = document.querySelectorAll('.active');
		activeElements.forEach(element => {
		  element.classList.remove('active');
		});
		e.target.classList.add('active');
	};
	
	document.querySelectorAll('.dashboard-menu-item').forEach(item => {
		item.addEventListener('click', handleSetActive);
	});
	
	return (
		<div>
			<Helmet>
				<title>Мои заявки на изменение персональных данных - Личный кабинет Enter Engineering</title>
			</Helmet>			
			<div className='dashboard'>
				<NavBar />
				<div className='dashboard-content'>
					{loading && (<div className='loader-container'>
						<Spin size="large"/>
					</div>)}
					<ApplicationsListContent applicationsData={applicationsData} />
				</div>
			</div>
		</div>
	);
}

export default ApplicationsList;
